import { StepIdsEnum } from '../../constants/project/projects-tour-enums';
import { windowIsSmall } from '../breakpoints/breakpoint.helpers';

export const getTourBoxPosition = (
	rect: DOMRect,
	verticalPosition: 'top' | 'bottom',
	topOffset: number,
	leftOffset: number,
	scrollTop: number,
	scrollLeft: number
): React.CSSProperties => {
	return {
		top: rect[verticalPosition] + scrollTop + topOffset,
		left: rect.left + scrollLeft + leftOffset
	};
};

export const getHighlightStyles = (
	currentStepId: StepIdsEnum,
	targetRect: DOMRect,
	scrollTop: number,
	scrollLeft: number
): React.CSSProperties => {
	const isOnCopyMoveStep = currentStepId === StepIdsEnum.COPY_MOVE;
	const isOnToolbarButtonStep = isToolbarButtonStep(currentStepId);
	const isProductActionButton = isProductActionButtonStep(currentStepId);

	const padding = isProductActionButton ? 6 : isOnToolbarButtonStep ? 5 : 0;
	const topPadding = isProductActionButton ? 6 : 0;
	const copyMoveStepWidth = windowIsSmall() ? 100 : 110;

	let height: number;
	if (isOnCopyMoveStep || isOnToolbarButtonStep) {
		height = 59;
	} else if (isProductActionButton) {
		height = targetRect.width + padding * 2;
	} else {
		height = targetRect.height + padding * 2;
	}

	return {
		top: targetRect.top - topPadding + scrollTop,
		left: targetRect.left - padding + scrollLeft,
		width: isOnCopyMoveStep ? copyMoveStepWidth : targetRect.width + padding * 2,
		height
	};
};

const {
	COPY_MOVE,
	COMPARE,
	ADD_TO_CART,
	NEW_GROUP,
	GROUP,
	SEARCH_FROM_PROJECTS,
	EDIT_PRODUCT,
	COMMENT,
	ORDERS_RETURNS,
	COMMUNICATION,
	PORTFOLIO
} = StepIdsEnum;

const isToolbarButtonStep = (id: StepIdsEnum | null): boolean => id !== null && [COMPARE, ADD_TO_CART, NEW_GROUP].includes(id);

export const isManagementStep = (id: StepIdsEnum | null): boolean => id !== null && [ORDERS_RETURNS, COMMUNICATION, PORTFOLIO].includes(id);

export const isGroupStep = (id: StepIdsEnum | null): boolean =>
	id !== null && [GROUP, SEARCH_FROM_PROJECTS, EDIT_PRODUCT, COMMENT].includes(id);

export const isToolbarStep = (id: StepIdsEnum | null): boolean => id !== null && [COPY_MOVE, COMPARE, ADD_TO_CART, NEW_GROUP].includes(id);

export const isProductActionButtonStep = (id: StepIdsEnum | null): boolean => id !== null && [EDIT_PRODUCT, COMMENT].includes(id);
